import React, { PropsWithChildren } from 'react';
import theme from './Banner.module.scss';
import { classnames } from '@/utils/html';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faQuestionCircle, faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type BannerType = 'info' | 'success' | 'warning' | 'danger';
const getDefaultIcon = (bannerType: BannerType) => {
    switch (bannerType) {
        case 'info':
            return faQuestionCircle;
        case 'warning':
            return faExclamationCircle;
        case 'danger':
            return faExclamationCircle;
        default:
            return null;
    }
};

interface BannerProps extends PropsWithChildren {
    type: BannerType;
    icon?: IconProp | null;
    className?: string;
    contentClassName?: string;
    stretch?: boolean;
}

const Banner: React.FC<BannerProps> = ({ type, children, icon, className, contentClassName, stretch }) => {
    const fixedIcon = icon === undefined ? (getDefaultIcon(type) as any) : icon;

    return (
        <div className={classnames(theme.banner, theme[type], { [theme.stretch]: stretch }, className)}>
            {fixedIcon && <FontAwesomeIcon icon={fixedIcon} />}
            <div className={contentClassName}>{children}</div>
        </div>
    );
};

export default Banner;